/* eslint-disable @typescript-eslint/no-explicit-any */
import { Collection, CollectionQuery } from "../../../models/collection.model"
import { ParkingLot } from "../../../models/parking-lot.model"
import { Sale } from "../../../models/sales.model"
import { notification } from "../../../shared/component/notification/utility/notification"
import { collectionQueryBuilder } from "../../../shared/utility/collection-builder/collection-query-builder"
import { appApi } from "../../../store/app.api"
import { PARKING_LOT_ENDPOINT } from "../parking-lot.endpoint"

let tenantCollection: CollectionQuery
let tenantCountCollection: CollectionQuery
let ownersOfTenantCollection: CollectionQuery
let archivedTenantCollection: CollectionQuery
const parkingLotQuery = appApi.injectEndpoints({
  endpoints: (builder) => ({
    getParkingLot: builder.query<ParkingLot, string>({
      query: (id: string) => ({
        url: `${PARKING_LOT_ENDPOINT.detail}/${id}`,
        method: "get",
      }),
      providesTags: ["Parking Lot"],
    }),

    getParkingLots: builder.query<Collection<ParkingLot>, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${PARKING_LOT_ENDPOINT.list}`,
        method: "GET",
        params: collectionQueryBuilder(data),
      }),
      providesTags: ["Parking Lots"],

      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // if (data) {
          //   SaleCollection = param
          // }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),
    countParkingLots: builder.query<any, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${PARKING_LOT_ENDPOINT.list}`,
        method: "GET",
        params: collectionQueryBuilder(data),
      }),
      providesTags: ["Count Parking Lots"],

      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // if (data) {
          //   SaleCountCollection = param
          // }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    // getOwnersOfSale: builder.query<Collection<Owner>, CollectionQuery>({
    //   query: (data: CollectionQuery) => ({
    //     url: `${PARKING_LOT_ENDPOINT.getOwnersOfSale}`,
    //     method: "GET",
    //     params: collectionQueryBuilder(data),
    //   }),
    //   async onQueryStarted(param, { queryFulfilled }) {
    //     try {
    //       const { data } = await queryFulfilled
    //       // if (data) {
    //       //   ownersOfSaleCollection = param
    //       // }
    //     } catch (error: any) {
    //       notification(
    //         "error",
    //         error?.error?.data?.message
    //           ? error?.error?.data?.message
    //           : "Error try again",
    //       )
    //     }
    //   },
    // }),

    getArchivedParkingLot: builder.query<ParkingLot, string>({
      query: (id: string) => ({
        url: `${PARKING_LOT_ENDPOINT.archivedParking}/${id}`,
        method: "get",
      }),
      providesTags: ["Archived Parking Lot"],
    }),

    getArchivedParkingLots: builder.query<Collection<Sale>, CollectionQuery>({
      query: (data: CollectionQuery) => ({
        url: `${PARKING_LOT_ENDPOINT.archivedParkingLots}`,
        method: "GET",
        params: collectionQueryBuilder(data),
      }),
      providesTags: ["Archived Parking Lots"],
      async onQueryStarted(param, { queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          // if (data) {
          //   archivedSaleCollection = param
          // }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    createParkingLot: builder.mutation<ParkingLot, any>({
      query: (newData: any) => ({
        url: `${PARKING_LOT_ENDPOINT.create}`,
        method: "post",
        data: newData,
        permissions: "manage-parking",
      }),
      invalidatesTags: ["Parking Lots", "Count Parking Lots"],
      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully created")
            // dispatch(
            //   parkingLotQuery.util.updateQueryData(
            //     "getTenants",
            //     tenantCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data.unshift(data)
            //         draft.count += 1
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    // importParkingLot: builder.mutation<ParkingLot, { id?: string; file?: any }>({
    //   query: (newData: { id?: string; file?: any }) => ({
    //     url: `${PARKING_LOT_ENDPOINT.import}/${newData.id}`,
    //     method: "post",
    //     data: newData?.file,
    //     permissions: "manage-sales",
    //   }),
    //   invalidatesTags: ["Sales", "Count Sales"],

    //   async onQueryStarted(param, { dispatch, queryFulfilled }) {
    //     try {
    //       const { data } = await queryFulfilled
    //       if (data) {
    //         notification("success", "Successfully created")
    //         // dispatch(
    //         //   parkingLotQuery.util.updateQueryData(
    //         //     "getTenants",
    //         //     tenantCollection,
    //         //     (draft) => {
    //         //       if (data) {
    //         //         draft.data.unshift(data)
    //         //         draft.count += 1
    //         //       }
    //         //     },
    //         //   ),
    //         // )
    //       }
    //     } catch (error: any) {
    //       notification(
    //         "error",
    //         error?.error?.data?.message
    //           ? error?.error?.data?.message
    //           : "Error try again",
    //       )
    //     }
    //   },
    // }),

    updateParkingLot: builder.mutation<ParkingLot, any>({
      query: (newData: any) => ({
        url: `${PARKING_LOT_ENDPOINT.update}`,
        method: "put",
        data: newData,
        permission: "manage-parking",
      }),
      invalidatesTags: ["Parking Lot", "Parking Lots"],
      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully updated")
            // dispatch(
            //   parkingLotQuery.util.updateQueryData(
            //     "getTenants",
            //     tenantCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft?.data?.map((tenant) => {
            //           if (tenant.id === data.id) return data
            //           else {
            //             return tenant
            //           }
            //         })
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message
              ? error?.error?.data?.message
              : "Error try again",
          )
        }
      },
    }),

    toggleParkingLotStatus: builder.mutation<ParkingLot, string>({
      query: (id: string) => ({
        url: `${PARKING_LOT_ENDPOINT.toggleStatus}/${id}`,
        method: "post",
        permission: "manage-parking",
      }),
      invalidatesTags: ["Parking Lot", "Parking Lots"],
      async onQueryStarted(param, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully updated status")
            // dispatch(
            //   parkingLotQuery.util.updateQueryData(
            //     "getTenants",
            //     tenantCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft?.data?.map((tenant: Tenant) => {
            //           if (tenant.id === data.id) return data
            //           else {
            //             return tenant
            //           }
            //         })
            //       }
            //     },
            //   ),
            // )
            // dispatch(
            //   parkingLotQuery.util.updateQueryData("getTenant", param, (draft) => {
            //     draft.enabled = data.enabled
            //   }),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),

    archiveParkingLot: builder.mutation<ParkingLot, { id: string; reason: string }>({
      query: (data) => ({
        url: `${PARKING_LOT_ENDPOINT.archive}`,
        method: "delete",
        data: data,
        permission: "manage-parking",
      }),
      invalidatesTags: ["Parking Lot", "Parking Lots"],
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            // dispatch(
            //   parkingLotQuery.util.updateQueryData(
            //     "getTenants",
            //     tenantCollection,
            //     (draft) => {
            //       draft.data = draft?.data?.map((tenant) => {
            //         if (tenant.id === arg.id) {
            //           return data
            //         } else {
            //           return tenant
            //         }
            //       })
            //     },
            //   ),
            // )
            // dispatch(
            //   parkingLotQuery.util.updateQueryData(
            //     "getTenant",
            //     arg?.id,
            //     (draft) => {
            //       draft.deletedAt = data?.deletedAt
            //     },
            //   ),
            // )
            // dispatch(
            //   parkingLotQuery.util.updateQueryData(
            //     "getArchivedTenant",
            //     arg?.id,
            //     (draft) => {
            //       draft.deletedAt = data?.deletedAt
            //     },
            //   ),
            // )
            notification("success", "Successfully archived")
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),

    deleteParkingLot: builder.mutation<boolean, string>({
      query: (id: string) => ({
        url: `${PARKING_LOT_ENDPOINT.delete}/${id}`,
        method: "delete",
        permission: "manage-parking",
      }),
      invalidatesTags: ["Parking Lot", "Parking Lots"],

      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            notification("success", "Successfully deleted")
            // dispatch(
            //   parkingLotQuery.util.updateQueryData(
            //     "getArchivedTenants",
            //     archivedTenantCollection,
            //     (draft) => {
            //       if (data) {
            //         draft.data = draft.data.filter((tenant) => tenant.id !== id)
            //         draft.count -= 1
            //       }
            //     },
            //   ),
            // )
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),

    restoreParkingLot: builder.mutation<ParkingLot, string>({
      query: (id: string) => ({
        url: `${PARKING_LOT_ENDPOINT.restore}/${id}`,
        method: "post",
        permission: "manage-parking",
      }),
      invalidatesTags: ["Parking Lot", "Parking Lots"],

      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled
          if (data) {
            // dispatch(
            //   parkingLotQuery.util.updateQueryData(
            //     "getTenants",
            //     tenantCollection,
            //     (draft) => {
            //       draft.data = draft?.data?.map((tenant) => {
            //         if (tenant.id === id) {
            //           return data
            //         } else {
            //           return tenant
            //         }
            //       })
            //     },
            //   ),
            // )
            // dispatch(
            //   parkingLotQuery.util.updateQueryData("getTenant", id, (draft) => {
            //     draft.deletedAt = data?.deletedAt
            //   }),
            // )
            // dispatch(
            //   parkingLotQuery.util.updateQueryData(
            //     "getArchivedTenant",
            //     id,
            //     (draft) => {
            //       draft.deletedAt = data?.deletedAt
            //     },
            //   ),
            // )
            notification("success", "Successfully restored")
          }
        } catch (error: any) {
          notification(
            "error",
            error?.error?.data?.message ?? "Error try again",
          )
        }
      },
    }),
    // removeSalesFile: builder.mutation<
    //   Sale,
    //   { saleId: string; filename: string }
    // >({
    //   query: (data: { saleId: string; filename: string }) => ({
    //     url: `${PARKING_LOT_ENDPOINT.removeFile}/${data.saleId}/${data.filename}`,
    //     method: "post",
    //     permission: "manage-sales",
    //   }),
    //   invalidatesTags: ["Sale", "Sales"],

    //   async onQueryStarted(id, { dispatch, queryFulfilled }) {
    //     try {
    //       const { data } = await queryFulfilled
    //       if (data) {
    //         notification("success", "Successfully deleted")
    //         // dispatch(
    //         //   leaseQuery.util.updateQueryData(
    //         //     "getRentIncreases",
    //         //     rentIncreaseCollection,
    //         //     (draft) => {
    //         //       if (data) {
    //         //         draft.data = draft.data.filter(
    //         //           (rentIncrease) => rentIncrease.id !== id,
    //         //         )
    //         //         draft.count -= 1
    //         //       }
    //         //     },
    //         //   ),
    //         // )
    //       }
    //     } catch (error: any) {
    //       notification(
    //         "error",
    //         error?.error?.data?.message ?? "Error try again",
    //       )
    //     }
    //   },
    // }),
  }),
  overrideExisting: true,
})
export const {
  useLazyCountParkingLotsQuery,
  useLazyGetArchivedParkingLotQuery,
  useLazyGetArchivedParkingLotsQuery,
  useLazyGetParkingLotQuery,
  useLazyGetParkingLotsQuery,
  useToggleParkingLotStatusMutation,
  useCreateParkingLotMutation,
  useUpdateParkingLotMutation,
  useDeleteParkingLotMutation,
  useArchiveParkingLotMutation,
  useRestoreParkingLotMutation,
} = parkingLotQuery
